import { bl_fi_einvoice_discrepancies_report_hdr_RowClass, bl_fi_einvoice_discrepancies_report_line_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class EinvoiceDiscrepanciesReportContainerModel extends BaseContainerModel {
    bl_fi_einvoice_discrepancies_report_hdr: bl_fi_einvoice_discrepancies_report_hdr_RowClass = new bl_fi_einvoice_discrepancies_report_hdr_RowClass();
    bl_fi_einvoice_discrepancies_report_lines: bl_fi_einvoice_discrepancies_report_line_RowClass[] = [];
}
